import React from 'react';

import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Icon from '@material-ui/core/Icon';
import { makeStyles } from "@material-ui/core/styles";
import { nonPronouns } from '../common';

const useStyles = makeStyles(theme => ({
    form: {
        display: 'flex',
        width: 810,
        maxWidth: '100%',
        marginLeft: 'auto',
        marginRight: 'auto',
        '& .MuiFormControl-root': {
            width: 500,
            maxWidth: '100%',
        },
        '& h2': {
            textTransform: 'uppercase',
            fontSize: '1.2rem',
            fontWeight: 400,
        },
    },
    paper: {
        padding: theme.spacing(3),
        marginTop: theme.spacing(3),
    },
    selectMenu: {
        '& .MuiMenu-list': {
            minWidth: 100
        }
    }
}));

const ApprovalFormInner = props => {
    const { wedding } = props;
    const classes = useStyles();

    const provinces = window.provinces;

    const [state, setState] = React.useState({
        'bride_email': wedding.bride_email,
        'groom_email': wedding.groom_email,
        'couple_address_same': wedding.couple_address_same,
        'couple_address': wedding.couple_address,
        'couple_city': wedding.couple_city,
        'couple_province_id': wedding.couple_province_id,
        'couple_postal': wedding.couple_postal,
        'couple_cell': wedding.couple_cell,
        'groom_address': wedding.groom_address,
        'groom_city': wedding.groom_city,
        'groom_province_id': wedding.groom_province_id,
        'groom_postal': wedding.groom_postal,
        'groom_cell': wedding.groom_cell,
        'wedding_planner_email': wedding.wedding_planner_email,
        'couple_referred': wedding.couple_referred,
        'referral_vendor_venue': wedding.referral_vendor_venue,
        'venue': wedding.venue,
        'location': wedding.location,
        'count_party': wedding.count_party,
        'count_flower': wedding.count_flower,
        'count_ring': wedding.count_ring,
        'wedding_colours': wedding.wedding_colours,
        'wedding_outside': wedding.wedding_outside,
        'email_list': wedding.email_list,
        'has_second_meeting': wedding.has_second_meeting,
        'location_meeting': wedding.location_meeting,
        'has_rehearsal': wedding.has_rehearsal,
        'location_rehearsal': wedding.location_rehearsal,
        'hash': wedding.hash,
    });

    const referredOptions = ['Bridal Show','Bridal Solutions','EventSource','Facebook','Family/Friend','Trade Sensations','Vendor','Venue','Vineyard Bride','Wedding Wire', 'Online search (Google, Yahoo, Bing)'];

    const referredValue = referredOptions.indexOf(state.couple_referred) >= 0 ? state.couple_referred : '';
    const referralType = ['Vendor','Venue','Bridal Show', 'Family/Friend'].indexOf(referredValue) >= 0 ? referredValue : false;

    const updateState = (value, name) => {
        const data = {
            ...state,
            [name]: value,
        };
        setState(data);
    }

    const handleChange = name => event => {
        let value;
        if (name == 'couple_address_same') {
            value = event.target.checked;
        } else {
            value = event.target.value;
        }
        updateState(value, name);
    }

    const handleSubmit = event => {
        event.preventDefault();
        const formData = {
            ...state,
            _token: window._token
        };
        new Promise((resolve, reject) => {
            let url = '/approval/form';
            fetch(url, {
                method: 'POST',
                body: JSON.stringify(formData),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => {
                    return response.json();
                })
                .then(result => {
                    if (result.errors) {
                        console.log(result.errors)
                    }
                    window.location = `/approval/terms?couple_hash=${result.wedding.hash}`;
                })
                .catch(reason => {
                    alert('An error prevented saving. Please refresh the page and try again.');
                })
        });
    }

    const getAddressValue = name => {
        return state.couple_address_same ? state[`couple_${name}`] : (state[`groom_${name}`] || '');
    }

    const pronouns = nonPronouns(wedding);

    return (
        <Grid container spacing={1}>
            <Grid item xs={12} align="center">
                <Box mb={2} mt={3}>
                    <Typography variant="h5" color="primary" style={{ fontSize: '1.30rem' }}>
                        {wedding.wedding_date_formatted} {wedding.wedding_time_formatted} ({wedding.time_zone_short})
                    </Typography>
                </Box>
            </Grid>
            <Grid item xs={12}>
                <form className={classes.form} onSubmit={handleSubmit}>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <h2>Couple's Information</h2>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <TextField
                                        id="bride-first-name"
                                        label={pronouns.bride}
                                        disabled
                                        value={wedding.bride_full_name}
                                        variant="outlined"
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        type="email"
                                        required
                                        id="bride-email"
                                        label={`${pronouns.bride} Email`}
                                        onChange={handleChange('bride_email')}
                                        value={state.bride_email || ''}
                                        variant="outlined"
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12} style={{height: 47, marginTop: 10}}>&nbsp;</Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        required
                                        id="bride-address"
                                        label={`${pronouns.bride} Address`}
                                        onChange={handleChange('couple_address')}
                                        value={state.couple_address || ''}
                                        variant="outlined"
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        required
                                        id="bride-city"
                                        label={`${pronouns.bride} City`}
                                        onChange={handleChange('couple_city')}
                                        value={state.couple_city || ''}
                                        variant="outlined"
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        select
                                        fullWidth
                                        required
                                        label={`${pronouns.bride} Province`}
                                        value={state.couple_province_id}
                                        onChange={handleChange('couple_province_id')}
                                        variant="outlined"
                                        SelectProps={{
                                            autoWidth: true
                                        }}
                                    >
                                        {provinces.map(option => (
                                            <MenuItem key={option.id} value={option.id}>
                                                {option.province_name}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        required
                                        id="bride-postal"
                                        label={`${pronouns.bride} Postal`}
                                        onChange={handleChange('couple_postal')}
                                        value={state.couple_postal || ''}
                                        variant="outlined"
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12} style={{marginTop: 30}}>
                                    <TextField
                                        required
                                        id="bride-cell"
                                        label={`${pronouns.bride} Cell`}
                                        onChange={handleChange('couple_cell')}
                                        value={state.couple_cell || ''}
                                        variant="outlined"
                                        fullWidth
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <TextField
                                        id="groom-first-name"
                                        label={pronouns.groom}
                                        disabled
                                        value={wedding.groom_full_name}
                                        variant="outlined"
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        type="email"
                                        required
                                        id="groom-email"
                                        label={`${pronouns.groom} Email`}
                                        onChange={handleChange('groom_email')}
                                        value={state.groom_email}
                                        variant="outlined"
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12} style={{height: 47, marginTop: 10}}>
                                    <FormGroup>
                                        <FormControlLabel
                                            control={
                                                <Checkbox color="primary" id="couple-address-same" checked={state.couple_address_same} onChange={handleChange('couple_address_same')} />
                                            }
                                            label={`Use same address as ${pronouns.bride.toLowerCase()}`}
                                        />
                                    </FormGroup>
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        required
                                        disabled={state.couple_address_same}
                                        id="groom-address"
                                        label={`${pronouns.groom} Address`}
                                        onChange={handleChange('groom_address')}
                                        value={getAddressValue('address')}
                                        variant="outlined"
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        required
                                        disabled={state.couple_address_same}
                                        id="groom-city"
                                        label={`${pronouns.groom} City`}
                                        onChange={handleChange('groom_city')}
                                        value={getAddressValue('city')}
                                        variant="outlined"
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        select
                                        fullWidth
                                        required
                                        disabled={state.couple_address_same}
                                        label={`${pronouns.groom} Province`}
                                        value={getAddressValue('province_id')}
                                        onChange={handleChange('groom_province_id')}
                                        variant="outlined"
                                        SelectProps={{
                                            autoWidth: true
                                        }}
                                    >
                                        {provinces.map(option => (
                                            <MenuItem key={option.id} value={option.id}>
                                                {option.province_name}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        required
                                        disabled={state.couple_address_same}
                                        id="groom-postal"
                                        label={`${pronouns.groom} Postal`}
                                        onChange={handleChange('groom_postal')}
                                        value={getAddressValue('postal')}
                                        variant="outlined"
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12} style={{marginTop: 30}}>
                                    <TextField
                                        required
                                        id="groom-cell"
                                        label={`${pronouns.groom} Cell`}
                                        onChange={handleChange('groom_cell')}
                                        value={state.groom_cell || ''}
                                        variant="outlined"
                                        fullWidth
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Box my={3}>
                                <Divider />
                            </Box>
                        </Grid>
                        <Grid item xs={12}>
                            <h2>Wedding Information</h2>
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container direction="row" spacing={2}>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        select
                                        fullWidth
                                        required
                                        onChange={handleChange('couple_referred')}
                                        label="Referred By"
                                        value={state.couple_referred || ''}
                                        variant="outlined"
                                        SelectProps={{
                                            autoWidth: true,
                                            required: true,
                                            native: true,
                                        }}
                                    >
                                        <option value=''></option>
                                        {referredOptions.map((option, k) => (
                                            <option key={k} value={option}>
                                                {option}
                                            </option>
                                        ))}
                                    </TextField>
                                </Grid>
                                {referralType && (
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            required
                                            fullWidth
                                            variant="outlined"
                                            onChange={handleChange('referral_vendor_venue')}
                                            label={`Name of Referral ${referralType}`}
                                            value={state.referral_vendor_venue || ''}
                                        />
                                    </Grid>
                                )}
                            </Grid>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                required
                                id="venue"
                                label="Venue"
                                onChange={handleChange('venue')}
                                value={state.venue || ''}
                                variant="outlined"
                                disabled={wedding.is_all_inclusive}
                                helperText={wedding.is_all_inclusive ? 'All inclusive wedding venue cannot be changed' : ''}
                                InputProps={wedding.is_all_inclusive ? {
                                    startAdornment: (
                                      <InputAdornment position="start">
                                        <Icon>lock</Icon>
                                      </InputAdornment>
                                    ),
                                  } : undefined}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                required
                                id="location"
                                label="Venue Street Address"
                                onChange={handleChange('location')}
                                value={state.location || ''}
                                variant="outlined"
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <TextField
                                        type="number"
                                        required
                                        id="count-wedding-party"
                                        label="Number in the Wedding Party Including Wedding Couple"
                                        onChange={handleChange('count_party')}
                                        value={state.count_party}
                                        variant="outlined"
                                        inputProps={{
                                            min: 0,
                                            max: 500
                                        }}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        type="number"
                                        required
                                        id="count-flower-girls"
                                        label="Flower Girls"
                                        onChange={handleChange('count_flower')}
                                        value={state.count_flower}
                                        variant="outlined"
                                        inputProps={{
                                            min: 0,
                                            max: 500
                                        }}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        type="number"
                                        required
                                        id="count-ring-bearers"
                                        label="Ring Bearers"
                                        onChange={handleChange('count_ring')}
                                        value={state.count_ring}
                                        variant="outlined"
                                        inputProps={{
                                            min: 0,
                                            max: 500
                                        }}
                                        fullWidth
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <TextField
                                        select
                                        fullWidth
                                        required
                                        label="Is the Wedding Outside?"
                                        value={state.wedding_outside}
                                        onChange={handleChange('wedding_outside')}
                                        variant="outlined"
                                        SelectProps={{
                                            autoWidth: true,
                                            MenuProps: {
                                                className: classes.selectMenu
                                            }
                                        }}
                                    >
                                        <MenuItem value={1}>Yes</MenuItem>
                                        <MenuItem value={0}>No</MenuItem>
                                    </TextField>
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        select
                                        fullWidth
                                        required
                                        label="Add to Email List"
                                        value={state.email_list}
                                        onChange={handleChange('email_list')}
                                        variant="outlined"
                                        SelectProps={{
                                            autoWidth: true,
                                            MenuProps: {
                                                className: classes.selectMenu
                                            }
                                        }}
                                    >
                                        <MenuItem value={1}>Yes</MenuItem>
                                        <MenuItem value={0}>No</MenuItem>
                                    </TextField>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                id="wedding-colours"
                                label="Wedding Colours"
                                onChange={handleChange('wedding_colours')}
                                value={state.wedding_colours || ''}
                                variant="outlined"
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                id="wedding-planner-email"
                                label="Wedding Planner Email (if applicable)"
                                onChange={handleChange('wedding_planner_email')}
                                value={state.wedding_planner_email || ''}
                                variant="outlined"
                                helperText="Do not use wedding venue contact email"
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Box my={3}>
                                <Divider />
                            </Box>
                        </Grid>
                        <Grid item xs={12}>
                            <h2>Additional Services</h2>
                        </Grid>
                        <Grid item xs={12}>
                            <p>Will you require a second meeting with {wedding.officiant ? wedding.officiant.name : 'the officiant'}? {wedding.is_all_inclusive_wedding ? '': '(Additional $100)'}</p>
                            <TextField
                                select
                                fullWidth
                                required
                                value={state.has_second_meeting}
                                onChange={handleChange('has_second_meeting')}
                                style={{width: 150}}
                                variant="outlined"
                                SelectProps={{
                                    autoWidth: true,
                                    MenuProps: {
                                        className: classes.selectMenu
                                    }
                                }}
                            >
                                <MenuItem value={true}>Yes</MenuItem>
                                <MenuItem value={false}>No</MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                disabled={!state.has_second_meeting}
                                id="second-meeting-location"
                                label="If possible, please provide the date, time and location"
                                onChange={handleChange('location_meeting')}
                                value={state.location_meeting || ''}
                                variant="outlined"
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <p>Will you require {wedding.officiant ? wedding.officiant.name : 'the officiant'} to lead your wedding rehearsal? {wedding.is_all_inclusive ? '': '(Additional $175)'}</p>
                            <TextField
                                select
                                fullWidth
                                required
                                value={state.has_rehearsal}
                                onChange={handleChange('has_rehearsal')}
                                style={{width: 150}}
                                variant="outlined"
                                SelectProps={{
                                    autoWidth: true,
                                    MenuProps: {
                                        className: classes.selectMenu
                                    }
                                }}
                            >
                                <MenuItem value={true}>Yes</MenuItem>
                                <MenuItem value={false}>No</MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                disabled={!state.has_rehearsal}
                                id="rehearsal-location"
                                label="If possible, please provide the date, time and location"
                                onChange={handleChange('location_rehearsal')}
                                value={state.location_rehearsal || ''}
                                variant="outlined"
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} style={{marginTop: 30, marginBottom: 20}}>
                            <Button type="submit" variant="contained" color="primary">Save Profile</Button>
                        </Grid>
                    </Grid>
                </form>
            </Grid>
        </Grid>
    );
}

const ApprovalForm = props => {
    const classes = useStyles();
    const { wedding } = props;

    return (
        <React.Fragment>
            <Grid container spacing={1}>
                <Grid item xs={12} align="center">
                    <Typography>To complete your reservation with Enduring Promises please complete the information below.</Typography>
                </Grid>
            </Grid>
            <Paper square className={classes.paper}>
                <ApprovalFormInner wedding={wedding} />
            </Paper>
        </React.Fragment>
    );
}

export default ApprovalForm;
